export enum GetPaidForms {
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  TRANSFERT_METHOD = 'TRANSFERT_METHOD',
  VERIFICATION = 'VERIFICATION'
}

export enum FormsStatus {
  NOT_REQUIRED = 'NOT_REQUIRED',
  REQUIRED = 'REQUIRED',
  FAILED = 'FAILED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  VERIFIED = 'VERIFIED',
  NOT_CREATED = 'NOT_CREATED',
  AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION',
  CONFIRMED = 'CONFIRMED'
}
